/*
 * @Author: panwl
 * @Date: 2020-04-22 19:19:12
 * @LastEditTime: 2020-04-22 19:23:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\Attachment\control\form-loaction-control.ts
 */
import { BaseControl } from '@cloudpivot/form/src/common/controls/base-control';
import { FromAddressValueService } from "@cloudpivot/form/src/common/services/form-address-value-service";
export class FormLocationControl extends BaseControl {
    constructor() {
        super(...arguments);
        this.val = {};
    }
    get address() {
        if (!this.ctrl.value) {
            return '';
        }
        const val = this.ctrl.value;
        return `${val.provinceName || ''}${val.cityName || ''}${val.districtName || ''}${val.address || ''}`;
    }
    get isEl() {
        // 
        return FormLocationControl.service.isEl();
    }
    position() {
        if (!FormLocationControl.service) {
            return;
        }
        let range;
        if (this.controlOpts.displayMode === 'accurate') {
            range = parseInt(this.controlOpts.range.substr(0, this.controlOpts.range.length - 1));
        }
        FormLocationControl.service.position(range, true).then(result => {
            FromAddressValueService.setAddressVal(result.adcode).then((value) => {
                this.ctrl.value = Object.assign(result, value);
            });
        });
    }
    navigation() {
        if (!FormLocationControl.service || !this.ctrl.value) {
            return;
        }
        const val = this.ctrl.value;
        FormLocationControl.service.navigation(val.lat, val.lng, val.address);
    }
    setControl() {
        this.handleValueChange(this.ctrl.value);
    }
    handleValueChange(value) {
        this.val = value || {};
    }
}
